import { StyledMuiTooltip } from './styles'

export const Tooltip = ({ children, ...rest }) => {
  return (
    <StyledMuiTooltip arrow {...rest}>
      {children}
    </StyledMuiTooltip>
  )
}
